import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { MediaBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { Embed } from "./Embed";
import { defaultData } from "./embedBlockDefaultData";

export const EmbedBlock: BlockExport = {
  type: "component",
  Block: Embed,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-embed-media",
    size: 24,
  },
  defaultData,
  meta: {
    name: "Embed",
    version: 1,
    nameI18n: "builder_ui.block_type.embed",
    category: [MediaBlock],
    props: {
      embed: {
        name: "URL",
        nameI18n: "builder_ui.prop_type.url",
        prop: "other",
        type: "oembed",
      },
    },
  },
};
